import api from './api';
import { Feiertag, CreateFeiertagDTO } from '../types';
import { toDateKey } from '../utils/dateUtils';

export const feiertagService = {
    getAllFeiertage: async (params?: { startDatum?: Date; endDatum?: Date }) => {
        const response = await api.get<Feiertag[]>('/feiertage', {
            params: {
                startDatum: params?.startDatum ? toDateKey(params.startDatum) : undefined,
                endDatum: params?.endDatum ? toDateKey(params.endDatum) : undefined,
            }
        });
        return response.data;
    },

    createFeiertag: async (data: CreateFeiertagDTO) => {
        const response = await api.post<Feiertag>('/feiertage', data);
        return response.data;
    },

    deleteFeiertag: async (id: number) => {
        const response = await api.delete(`/feiertage/${id}`);
        return response.data;
    }
};
